export class CatGoalStateModel {
    public stateGoalId?:number;
    public stateDescription?:string;

    public commission?:number;
    public commissionFisofo?:number;

    public activeId?:boolean;
    public activeIdFisofo?:boolean;

    public createUserId?:number;
    public createDate?:string;
    public modifUserId?:number;
    public modifDate?:string;
}
